import { Box, ColorOptions, IconNew, Image, Text } from '@jfs/ui-new'
import { colors } from '../../util/colors'

const mobileWeb = require('../../assets/images/mobile-web.svg')
const mobileWebUnselected = require('../../assets/svg/pg-unselected.svg')
const data = [
  {
    id: 0,
    src: [mobileWeb, mobileWebUnselected],
    title: 'PAYMENT GATEWAY',
    key: 'pg',
  },
  {
    id: 1,
    icon: 'POS',
    title: 'POINT OF SALE',
    key: 'pos',
  },
  {
    id: 2,
    icon: 'RECEIVE_MONEY',
    title: 'UPI HUB',
    key: 'upihub',
  },
  {
    id: 3,
    icon: 'INVOICES',
    title: 'BILLER CENTER',
    key: 'biller',
  },
  {
    id: 4,
    icon: 'MOBILE_PAY',
    title: 'BUSINESS APP',
    key: 'jiobizz',
  },
]
export const ProductsTab = ({ onLayout, selectedIndex }: any) => {
  const scrollTo = (key: string) => {
    if (window && document) {
      const element = document.getElementById(key)
      if (element) {
        setTimeout(() => {
          element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start',
          })
        }, 100)
      }
    }
  }
  return (
    <Box onLayout={onLayout && onLayout}>
      <Box flexDirection={'row'} borderRadius={8}>
        {data.map((item: any, index: number) => {
          return (
            <Box
              justify="space-between"
              justifyContent={'center'}
              align={'center'}
              f={1}
              pv={24}
              h={105}
              borderRightWidth={index === 4 ? 0 : 1}
              borderRightColor={'GREY_1_SEPARATOR'}
              borderRadius={selectedIndex === index ? 8 : 0}
              borderTopLeftRadius={index === 0 || selectedIndex === index ? 8 : 0}
              borderBottomLeftRadius={index === 0 || selectedIndex === index ? 8 : 0}
              borderTopRightRadius={index === 4 || selectedIndex === index ? 8 : 0}
              borderBottomRightRadius={index === 4 || selectedIndex === index ? 8 : 0}
              underlayColor={
                selectedIndex === index ? (colors.JIO_PRIMARY_ALPHA as ColorOptions) : (colors.HOVER_BG as ColorOptions)
              }
              onPress={() => [scrollTo(item.key)]}
              bg={
                selectedIndex === index ? (colors.JIO_PRIMARY_ALPHA as ColorOptions) : (colors.HOVER_BG as ColorOptions)
              }>
              {!!item.src && (
                <Image source={selectedIndex === index ? item.src[0] : item.src[1]} height={32} width={32} />
              )}
              {!!item.icon && (
                <IconNew
                  id={item.icon}
                  size={32}
                  color={selectedIndex === index ? 'WHITE' : (colors.JIO_PRIMARY_ALPHA as ColorOptions)}
                />
              )}
              <Text
                title={item.title}
                fontFamily={'jiotype-bold'}
                fontSize={12}
                color={selectedIndex === index ? 'WHITE' : (colors.JIO_PRIMARY_ALPHA as ColorOptions)}
                letterSpacing={2.4}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
